export const PROJECT_NAME = process.env.VUE_APP_PROJECT_NAME;
const NODE_ENV = process.env.NODE_ENV;
let base_url = "";
switch (NODE_ENV) {
  case "development":
    // base_url = "http://192.168.0.206:8009";
    base_url = "http://193.168.1.59:8009";
    // base_url = "https://sxgw.bsjuli.com";
    break;
  case "test":
    base_url = "http://192.168.0.133:8009";
    break;
  case "production":
    base_url = "https://sxgw.bsjuli.com";
    break;
  default:
    console.error("process.env.NODE_ENV not set!");
    break;
}
export const VUE_APP_BASE_API = base_url;
export const UPLOAD_FILE_URL = VUE_APP_BASE_API + "/api/v1/attachFile/upload/";
export const USE_MOCK = process.env.NODE_ENV === "development" ? false : false;
const TELEPHONE = "";
const CONTACT_EMAIL = "kfxxwl@163.com";
export const CONTACT_INFOMATION = CONTACT_EMAIL;
export const EXPERIENCE_ADDRESS = 'https://sx.bsjuli.com/user/login?a=gyhlw123&p=jd123456';

export const REGISTER_URL = "https://shifan.ningxin-iiot.com/register";
